'use client'

import { UserModel } from '@/db/schema';
import { createContext, useContext, useState } from 'react';

type AuthUser = {
    service: string;
    user?: object | string | null;
    cadet_no?: string | null;
    password?: string | null;
    token?: string | null;
    profile?: UserModel | null;
};

type AuthContextType = {
    user: AuthUser | null;
    setUser: React.Dispatch<React.SetStateAction<AuthUser | null>>;
    token: string | null;
    setToken: React.Dispatch<React.SetStateAction<string | null>>;
    profile: UserModel | null;
    setProfile: React.Dispatch<React.SetStateAction<UserModel | null>>;
    redirect?: string | null;
    setRedirect: (redirect: string | null) => void;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [ user, setUser] = useState<AuthUser | null>(null);
    const [ profile, setProfile ] = useState<UserModel | null>(null);
    const [ token, setToken ] = useState<string | null>(null);
    const [ redirect, setRedirect ] = useState<string | null>(null);

    return (
        <AuthContext.Provider value={{ user, setUser, token, setToken, profile, setProfile, redirect, setRedirect }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within AuthProvider');
    return context;
};

export default AuthContext;